import { Box, Stack, Typography } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"
import Iconify from "minimals-template/components/Iconify"
import { COLOR_FROM_CLASSIFICATION, ICON_FROM_CLASSIFICATION } from "library/SFG20/constants"
import { Repeat } from "lib/@components/repeat"
import { TailoredValue } from "routes/asset-register/plugins/general-tailoring/tailored-value"
import { TailoredScheduleTitle } from "./tailored-schedule-title"
import { createSlot } from "lib/@components/slot/create-slot"
import { isTailoringEvent } from "./lib/is-tailoring-event"

export const TailoredChangedTitleAbove = createSlot("TailoredChangedTitleAbove")

export function TailoredChanges({ payload }) {
    if (!isTailoringEvent(payload) || !payload.tailored) return null

    const { taskTitle, original, tailored } = payload
    const currentClassfication = tailored.classification ?? original.classification

    const updatedOriginal = { ...original, frequency: { label: original.frequency } }
    const updatedtailored = { ...tailored, frequency: { label: tailored.frequency } }

    const tailoredEntries = Object.entries(tailored)
        .filter(([t, v]) => v !== null && !t.startsWith("_"))
        .map("0")

    return (
        <Stack spacing={1} mb={1}>
            <TailoredChangedTitleAbove.Slot>
                <TailoredScheduleTitle payload={payload} />
            </TailoredChangedTitleAbove.Slot>
            <ListItemBox spacing={1} sx={{ my: 0 }}>
                <Iconify
                    icon={ICON_FROM_CLASSIFICATION[currentClassfication]}
                    sx={{ color: COLOR_FROM_CLASSIFICATION[currentClassfication] }}
                />
                <Typography variant="subtitle2" sx={{ pr: 1 }}>
                    {taskTitle}
                </Typography>
            </ListItemBox>

            <Box>
                <Repeat
                    list={tailoredEntries}
                    item={
                        <TailoredValue
                            original={updatedOriginal}
                            tailored={updatedtailored}
                            chipSx={{ width: "100%", justifyContent: "normal" }}
                        />
                    }
                />
            </Box>
        </Stack>
    )
}
